import React from "react";
import { Card, Paper, Box, Typography } from "@mui/material";

export default function StripedGuide({ images = [], titles = [], heading = "" , cardMaxWidth = "450px" }) {
  return (
    <section>
            <Box
              sx={{
                width: "100%",
                height: "18px",
                background: 'repeating-linear-gradient(45deg, #000 0 35px, #FFD700 35px 70px)',
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Typography sx={{ color: "#fff", fontWeight: "bold", fontSize: 18, lineHeight: 1 }}>
                nur Anleitung
              </Typography>
            </Box>
    </section>
  );
}